module.exports = __webpack_public_path__ + "img/windows-hero.9a199f50.png";